<i18n src='./i18n/main.json'></i18n>
<template>
<div id="app" class="container-fluid" dir="rtl" v-bind:lang="locale">

  <div id="wrapper" v-bind:class="{ toggled: isToggle }">
    <flash-message class="flashpool no-print"></flash-message>
    <!-- Sidebar -->
    <div id="sidebar-wrapper" class="no-print">
      <div id="info">
        <div>
          {{ ls_read_logged_in_as().as }}
        </div>
      </div>
      <!-- <ul class="nav flex-column" v-if="ls_auth() == 1"> -->
      <ul class="nav flex-column">
        <li class="nav-item" v-if="ls_read_logged_in_as().as === 'guest'">
          <router-link to="/login" class="nav-link" href="#">
            <span>
              <i class="ti-lock">&nbsp;</i>כניסת משתמש</span>
          </router-link>
        </li>
        <li class="nav-item" v-if="ls_read_logged_in_as().as !== 'guest'">
          <router-link to="#" @click.native="signOut" class="nav-link" href="#">
            <span>
              <i class="ti-unlock">&nbsp;</i>יציאה</span>
          </router-link>
        </li>

        <li class="nav-item" v-if="ls_read_logged_in_as().as !== 'guest'">
          <router-link to="/docs/orders" class="nav-link" href="#">
            <span>
              <i class="ti-shopping-cart">&nbsp;</i>הזמנות</span>
          </router-link>
        </li>

        <li class="nav-item" v-if="ls_read_logged_in_as().as !== 'guest'">
          <router-link to="/docs/price_quotes" class="nav-link" href="#">
            <span>
              <i class="ti-shopping-cart">&nbsp;</i>הצעות מחיר</span>
          </router-link>
        </li>
        <li class="nav-item" v-if="ls_read_logged_in_as().as !== 'guest'">
          <router-link to="/clients" class="nav-link" href="#">
            <span>
              <i class="ti-user">&nbsp;</i>לקוחות</span>
          </router-link>
        </li>
        <!-- <li class="nav-item" v-if="ls_read_logged_in_as().as !== 'guest'">
          <router-link to="/vendors" class="nav-link" href="#">
            <span>
              <i class="ti-truck">&nbsp;</i>ספקים</span>
          </router-link>
        </li> -->
        <li class="nav-item" v-if="ls_read_logged_in_as().as !== 'guest'">
          <router-link to="/items" class="nav-link" href="#">
            <span>
              <i class="ti-layers">&nbsp;</i>מוצרים</span>
          </router-link>
        </li>

        <li class="nav-item" v-if="ls_read_logged_in_as().as !== 'guest'">
          <a @click="download_backup" class="nav-link" href="#">
            <span>
              <i class="ti-layers">&nbsp;</i>הורזת גיבוי</span>
          </a>
        </li>

      </ul>
      <div id="user_links">
        <br />
        <div v-if="ls_auth() == 1">
          logged_in_as':
          <br />
          <span class="yellow01">{{ ls_read_logged_in_as().as != null ? ls_read_logged_in_as().as : 'guest' }}</span>
        </div>
        <div v-if="ls_auth() == 1">
          user_name:
          <br />
          <span class="yellow01">{{ ls_read_user_name().as != null ? ls_read_user_name().as : 'guest' }}</span>
        </div>
        <div v-if="ls_auth() == 1">
          <span v-on:click="loadSignOutWindow()" style="cursor:pointer;">
            <i class="ti-new-window"></i>sign_out</span>
        </div>
      </div>



      <div id="brand">
        <p style="text-align:left;">
          <a dir="ltr" style="text-decoration:none;color:lightgreen;" href="https://api.acro.link/atm/ARJ22OAJAALVIMTMFZKU2ZXWXHOJAFUP" target="_blank">SYSTEM ON</a>
        </p>
        <p style="text-align:left;">
          <a dir="ltr" style="text-decoration:none;color:yellow;" href="https://api.acro.link/atm/CELOC6T0R563PRL3CY33492WUQHHQHWQ" target="_blank">SYTEM OFF</a>
        </p>
        <a dir="ltr" style="text-decoration:none;color:#fff;" href="https://www.acro.link/" target="_blank">© ACROLINK 2019</a>
      </div>
    </div>

    <div id="page-content-wrapper">
      <div class="container-fluid">
        <!-- <div style="font-size:1.4em;" class="no-screen">{{ ls_institute_name }}</div> -->
        <div id="meta" class="no-print">
          <div>
            <button @click="toggle" class="btn btn-secondary" id="menu-toggle">
              <i class="ti-menu"></i>
            </button>
          </div>
          <select v-model="locale" class="form-control">
            <!-- <option value="ar">العربية</option> -->
            <option value="he">עברית</option>
          </select>
        </div>
        <transition name="fade" mode="out-in">
          <router-view v-cloak/>
        </transition>
      </div>
    </div>

  </div>

  <sweet-modal ref="sign_out_window">
    <h2>do_you_want_to_sign_out</h2>
    <div class="form-group">
      <button v-on:click="signOut" class="btn btn-error">yes</button>
      <button class="btn btn-default">no</button>
    </div>
  </sweet-modal>

</div>

<!--
  <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    
    <router-view/>

-->
</template>




<script>
import { SweetModal } from 'sweet-modal-vue'
export default {
  components: {
    SweetModal
  },
  name: 'App',
  data() {
    return {
      locale: this.$store.getters.locale,
      isToggle: true
    }
  },
  created() {
    this.$i18n.locale = this.$store.getters.locale
  },
  mounted: function() {
    this.init()
  },
  watch: {
    locale(val) {
      this.$store.commit('set_locale', val)
      this.$i18n.locale = this.$store.getters.locale
    }
  },
  methods: {
    init: function() {},

    download_backup: function() {
      console.log('download_backup..')

      let vm = this
      this.$axios
        .get('/api/generate_backup', { headers: vm.authorization(), responseType: 'blob' })
        .then(function(response) {
          console.log(response.headers)

          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', response.headers.fname) //or any other extension
          document.body.appendChild(link)
          link.click()
          //vm.flash('logged_out_successfully', 'success')
        })
        .catch(function(error) {
          // handle error
          console.log(error)
          // vm.flash('error_logging_out', 'error')
        })
        .then(function() {
          // always executed
        })
    },
    toggle: function() {
      this.isToggle = !this.isToggle
    },
    loadSignOutWindow: function() {
      console.log('loadSignOutWindow loaded..')
      this.$refs.sign_out_window.open()
    },
    signOut: function() {
      var vm = this
      vm.$ls.set('access_token', null)
      vm.$router.push('/login')
      vm.flash(vm.$t('logged_out_successfully'), 'success')

      /*
      console.log('sign_out_clicked..')
      let vm = this
      this.$axios
        .get('/api/auth/sign_out')
        .then(function(response) {
          // handle success
          console.log(response)
          vm.flash('logged_out_successfully', 'success')
        })
        .catch(function(error) {
          // handle error
          console.log(error)
          vm.flash('error_logging_out', 'error')
        })
        .then(function() {
          // always executed
          vm.reset_on_401()
          vm.$refs.sign_out_window.close()
          vm.$router.push('/login')
        })
        */
    }
  }
}
</script>


<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

<style lang="css">
@import 'https://libs.acro.link/fonts/ar/jf/styles.css';
</style>
<style lang="scss">
@import './assets/sass/general.scss';
@import './assets/sass/screen_n_print.scss';
@import './assets/sass/sidebar.scss';
</style>